import React from "react";

// import "./FtLineUp.scss";
import NextImage from "../NextImage";

const SubstitutionTable = ({ home, away }) => {
  const baseURL = process.env.REACT_APP_BASE_URL ?? "https://ipublisher-microservices.6lgx.com";

  const renderSubstitutionList = (substitutions) =>
    substitutions?.map((sub) => (
      <li key={sub?.sno}>
        <span className="ft_lineup_num">{sub?.sno}</span>
        <div className="teams_wrap">
          {sub?.sub === 1 && (
            <div className="teams-logo">
              <NextImage
                src={`${baseURL}/public/assets/images/svg/up-arrow2.svg`}
                height={13}
                width={13}
                alt="teamLogo"
                priority={false}
              />
            </div>
          )}
          <div className="teams-name">
            <span className="team_name">{sub?.nm}</span>
          </div>
        </div>
      </li>
    ));

  return (
    <div className="football_lineup_box">
      <div className="ft_lineup_columns">
        <ul className="ft_list_lineup">{renderSubstitutionList(home)}</ul>
        <ul className="ft_list_lineup">{renderSubstitutionList(away)}</ul>
      </div>
    </div>
  );
};

export default SubstitutionTable;
